import { motion } from "framer-motion";
import colors from "../../styles/colors";
import Button from "../Button";
import { useTranslation } from "react-i18next";

const ProductsSection = () => {
  const { t } = useTranslation();
  return (
    <section
      className="relative w-full h-auto flex justify-center items-center px-8 lg:px-20 py-16 bg-cover bg-center overflow-hidden"
      style={{
        backgroundImage:
          "url('/assets/images/home/ProductSection/light_bg.webp')",
      }}
    >
      {/* Container (világos háttér) */}
      <div
        className="flex flex-col max-h- screen md:flex-row w-full max-w-6xl rounded-xl overflow-hidden shadow-lg"
        style={{ backgroundColor: colors.pastelCream }}
      >
        {/* Kép (bal oldalon) */}
        <motion.img
          src="/assets/images/home/ProductSection/int_door.webp"
          alt={t("image_alt.products_sec")}
          loading="lazy"
          className="w-full md:w-1/2 h-auto object-cover"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: false, amount: 0.5 }}
        />

        {/* Szöveges tartalom (jobb oldalon) */}
        <div className="w-full md:w-1/2 flex flex-col justify-center items-start p-12 md:p-12 space-y-10">
          <motion.h2
            className="lg:text-7xl text-4xl md:text-5xl font-serif"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: false, amount: 0.5 }}
            style={{ color: colors.darkBrown }}
          >
            {t("productsSection.title")}
          </motion.h2>
          <motion.p
            className="lg:text-2xl text-lg md:text-xl font-serif"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true, amount: 0.5 }}
            style={{ color: colors.darkBrown }}
          >
            {t("productsSection.text")}
          </motion.p>
          <Button to={"/products"} text={t("productsSection.button")} />
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
